import React from "react";

function Loader() {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white/60 backdrop-blur-sm z-50">
      <div className="w-16 h-16 border-4 border-fuchsia-700 border-t-transparent rounded-full animate-spin"></div>
    </div>
  );
}

export default Loader;
